// extracted by mini-css-extract-plugin
export var back = "transition-weekly-report-details-module--back--0ebfa";
export var backIcon = "transition-weekly-report-details-module--back-icon--31882";
export var box = "transition-weekly-report-details-module--box--39603";
export var boxes = "transition-weekly-report-details-module--boxes--cb9ca";
export var checkbox = "transition-weekly-report-details-module--checkbox--7a989";
export var checkboxLabel = "transition-weekly-report-details-module--checkbox-label--5357a";
export var container = "transition-weekly-report-details-module--container--b977a";
export var content = "transition-weekly-report-details-module--content--9ffc0";
export var errorText = "transition-weekly-report-details-module--error-text--cc899";
export var header = "transition-weekly-report-details-module--header--69bba";
export var headerTop = "transition-weekly-report-details-module--header-top--31655";
export var loader = "transition-weekly-report-details-module--loader--ed962";
export var name = "transition-weekly-report-details-module--name--410e3";
export var sent = "transition-weekly-report-details-module--sent--024c8";
export var statusBox = "transition-weekly-report-details-module--status-box--d6346";
export var statusDot = "transition-weekly-report-details-module--status-dot--451c3";